// extracted by mini-css-extract-plugin
export var borderRadius = "_6e-4";
export var large = "_6e-3";
export var logoContainer = "_6e-0";
export var nameLogo = "_6e-2";
export var small = "_6e-1";